<template>
  <div id="pegasus" class="row">
    <div class="col">
      <h3 class="game-heading text-white mb-4">Pegasus</h3>
      <fish-shooting :games="this.pegasusFsGames" />
    </div>
  </div>
</template>

<script>
import FishShooting from "@/components/FishShooting.vue";

export default {
  name: "Pegasus",
  components: {
    FishShooting,
  },
  computed: {
    pegasusFsGames() {
      let games = this.$store.state.pegasusFsGames;

      // let maxValuesArr = games.filter((g) => {
      //   const maxPercent = Math.max.apply(
      //     Math,
      //     games.map(function (game) {
      //       return game.percent;
      //     })
      //   );

      //   return g.percent === maxPercent;
      // });

      // const bestGamesID = maxValuesArr.map((item) => {
      //   return item.id;
      // });

      games.forEach((g) => {
        g.cssClasses = `game text-white rounded-3`;
        if (g.percent >= 97) {
          g.cssClasses = `${g.cssClasses} best-game-color`;
        }
      });

      return games;
    },
  },
};
</script>
